module.exports = __webpack_public_path__ + "img/MFR-1110.06c73b41.jpg";